import { DurabilityIncidenceProportion } from '../../../../types';
export var list = [
    DurabilityIncidenceProportion.MIN_TWENTY_FIVE_PERCENT,
    DurabilityIncidenceProportion.MIN_FIFTY_PERCENT,
    DurabilityIncidenceProportion.MIN_SEVENTY_FIVE_PERCENT,
    DurabilityIncidenceProportion.FULL,
];
